import React from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { useUserStore } from "@client/store/user";
import { TopicLibraryPanel } from "./topics/TopicLibraryPanel";
import { Spinner } from "./ui/spinner";

export const Loading = () => (
  <div className="flex h-screen w-screen items-center justify-center bg-background">
    <Spinner size="lg" />
  </div>
);

export const AuthWrapper: React.FC = () => {
  const user = useUserStore((s) => s.user);
  const { pathname } = useLocation();

  if (user === null) return <Loading />;

  if (user === false) {
    if (pathname !== "/login") return <Navigate to="/login" replace />;
    return <Outlet />;
  }

  // user is UserSafe (logged in)
  if (pathname === "/login") return <Navigate to="/" replace />;
  return (
    <>
      <Outlet />
      <TopicLibraryPanel />
    </>
  );
};

export const RootElement: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <React.Suspense fallback={<Loading />}>{children}</React.Suspense>
);
